import config from '../../config';

export default (url?: string, params?: any, service: string = 'atlas') =>
  [config.url, service, url, params]
    .filter(Boolean)
    .join('/')
    .replace(/([^:])(\/\/+)/g, '$1/');
